import React from "react";

const General = () => {
  return <div><h2>General Home Page</h2></div>;
};

export default General;
